import { useQuery } from '@tanstack/react-query';

import type { BoardConfig, Project } from '@tasks/contracts';

import { listBoards } from '../api/boards';
import { queryKeys } from '../api/queryKeys';

export type ProjectBoardsView = {
  readonly boards: readonly BoardConfig[];
  readonly defaultBoard: BoardConfig | null;
  readonly isLoading: boolean;
};

/**
 * Доски проекта и доска по умолчанию. Меню «Доски» и страница доски читают
 * один запрос: переключение между ними не перезагружает список.
 */
export function useProjectBoards(key: string | undefined): ProjectBoardsView {
  const query = useQuery({
    queryKey: queryKeys.projects.boards(key ?? ''),
    queryFn: ({ signal }) => listBoards(key as string, signal),
    enabled: Boolean(key),
    staleTime: 60_000,
  });

  const boards = query.data ?? [];
  return {
    boards,
    defaultBoard: boards.find((board) => board.isDefault) ?? boards[0] ?? null,
    isLoading: query.isPending,
  };
}

/** Проект без доски открывать нечем: доска по умолчанию — резервный маршрут. */
export function defaultBoardPath(project: Project | null, boards: readonly BoardConfig[]): string | null {
  if (!project) return null;
  const board = boards.find((item) => item.isDefault) ?? boards[0];
  return board ? `/projects/${project.key}/boards/${board.id}` : null;
}